import { Pass } from '../../faceEffectPass'
// import VS from '!raw-loader!glslify-loader!./vertex.vert'
// import FS from '!raw-loader!glslify-loader!./fragment.frag'


//TEMPORARY PASSING THIS WAY AS  glslify-loader/raw-loader/Raw-body/@parcel/transformer-glsl not working --come back to this
const VS = /*glsl*/`
precision mediump float;
varying vec2 vUv;
uniform mat3 uTextureMatrix;

void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.);
}

`;

const FS = /*glsl*/`
precision mediump float;

varying vec2 vUv;
uniform vec3 uResolution;
uniform mat3 uTextureMatrix;
uniform sampler2D uTexture;

float getdistSqr(vec2 distance) {
  return pow(distance.x, 2.0) + pow(distance.y, 2.0);
}

float distanceTo(vec2 featurePosition, float blendRadius, vec2 distortion) {
  vec2 position = featurePosition.xy;
  vec2 distance = (vUv.xy - position.xy);

  distance -= (distance * distortion);

  return (getdistSqr(distance) / blendRadius) / blendRadius;
}

// https://github.com/jamieowen/glsl-blend/blob/master/soft-light.glsl


vec3 blendNormal(vec3 base, vec3 blend) {
	return blend;
}

vec3 blendNormal(vec3 base, vec3 blend, float opacity) {
	return (blendNormal(base, blend) * opacity + base * (1.0 - opacity));
}

void main() {
  vec2 uv = gl_FragCoord.xy / uResolution.xy * vec2(2,2) - vec2(0.5,0.5) ;
  vec3 c = texture2D(uTexture, uv.xy).rgb +  vec3(0., 0., 0.);
  
  // float fadedEdge = distanceTo(vec2(0.5, 0.5), 2.0, vec2(0, 0));
  // float blend = smoothstep( fadedEdge , -0.01, 0.01 ) * 1.5;
  
  // vec3 finalColor = blendNormal(c, vec3(0.463,0.647,0.549), blend);

  // c = mix(c,vec3(1.0, 1.0, 1.0), 1.);

  gl_FragColor = vec4(c, 1.0);
}

`;


export class FadeEdgesPass  extends Pass {
  public constructor() {
    super(VS, FS);
  }
}
